module.exports = __webpack_public_path__ + "static/Logo_GU-color-9b665e1840f3193a087678fc3581942f.jpg";